
import Http from "../../http/client";
import Store from "../index";

export default async () => {
  const response = await Http.get('admin/vehicle/category');
  Store.commit('SetVehicleCategory', response.data);
}
